import React, { useState, useEffect } from 'react'
import { Formik } from 'formik';

import GenericMultipleSelect from '../../../../../../components/molecules/GenericMultipleSelect';
import GenericDrawerValidationButtons from '../../../../../../components/molecules/GenericDrawerValidationButtons';

import {
  StyledAccordion,
  StyledForm,
  // InputGroup,
} from './style'

const SpecificCaseFilter = ({
  sitesData,
  setFilterConditions
}) => {
  const [sitesList, setSitesList] = useState([]);

  useEffect(() => {
    if (sitesData != null) {
      const newList = sitesData.map((service) => {
        return { label: service.name, value: service.id }
      })
      setSitesList(newList)
    }
  }, [sitesData])

  const formInitValue = {
    sites: [],
  }

  const handleResetForm = (props) => {
    props.resetForm();
    setFilterConditions(formInitValue);
  }

  return (
    <StyledAccordion
      headerComponent={"Recherche"}
      detailComponent={
        <Formik
          initialValues={formInitValue}
          setFieldValue
          onSubmit={(values) => setFilterConditions(values)}
        >
          {props => (
            <StyledForm>
              <GenericMultipleSelect
                id="sites"
                name="sites"
                onChange={(e, value) => props.setFieldValue('sites', value)}
                value={props.values.sites}
                list={sitesList}
                fildName="sites"
                title="sites"
              />
              <GenericDrawerValidationButtons
                leftButonText={'Réinitialiser'}
                RightButtonText={'Chercher'}
                onclickLefttButton={() => handleResetForm(props)}
                submitable={true}
              />
            </StyledForm>
          )}
        </Formik>
      }
    />
  )
}

export default SpecificCaseFilter;
